import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Warm empty-state with the boutique welcome illustration. */
export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex animate-rise flex-col items-center justify-center gap-4 px-6 py-12 text-center",
        className
      )}
    >
      <div className="relative h-28 w-44 overflow-hidden rounded-xl ring-1 ring-border/60 shadow-card">
        <img
          src="/brand/welcome-scene.png"
          alt=""
          className="h-full w-full object-cover object-[50%_58%]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-card/45 to-transparent" />
      </div>
      <div className="space-y-1">
        <p className="font-display text-lg font-medium tracking-tight text-foreground">{title}</p>
        {description ? (
          <p className="mx-auto max-w-sm text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
